import React from "react";
import { useSearchParams } from "react-router-dom";

import { PublicKycStatusLayout } from "../vkyc/PublicKycLayout";

const FAILED_TIPS = [
  "Try again between 9 AM to 7 PM IST, Monday to Saturday",
  "Ask your agent/consultant to generate a new link",
  "Keep your Aadhaar and PAN ready before you start",
];

const THANK_YOU_TIPS = [
  "You can close this window now",
  "Keep support details handy",
  "Your agent can share the latest status",
];

const KycConfirmationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const operatorStatus = (
    searchParams.get("operator_status") ||
    searchParams.get("operator_decision") ||
    ""
  ).toLowerCase();

  if (operatorStatus === "rejected") {
    return (
      <PublicKycStatusLayout
        contextTitle="We could not complete this KYC"
        contextBody="Your Video KYC could not be completed this time. This could be due to a poor internet connection, incomplete document verification, or agent unavailability."
        tips={FAILED_TIPS}
        tone="error"
        statusTitle="KYC could not be completed"
        statusDescription="Please request a new link from your agent or consultant to continue."
      />
    );
  }

  if (operatorStatus === "verified") {
    return (
      <PublicKycStatusLayout
        contextTitle="Your video KYC is verified"
        contextBody="Thank you for completing your Video KYC. Your KYC status will be updated automatically."
        tips={["You can close this window now"]}
        tone="success"
        statusTitle="KYC Successful"
      />
    );
  }

  return (
    <PublicKycStatusLayout
      contextTitle="Your details are with us"
      contextBody="We have received your KYC submission. Our team will review it and update your status."
      tips={THANK_YOU_TIPS}
      tone="thanks"
      statusTitle="Thank you"
      statusDescription="Your KYC details have been submitted successfully. You can close this window now."
    />
  );
};

export default KycConfirmationPage;
